import { Address } from "viem";

import { PortfolioSymbol, type PortfolioSymbolType } from "#/types/markets";
import { type Token } from "#/types/token";

import { environment } from "../environment";
import { ChainId } from "./contractAddresses";

export const tokens: Record<PortfolioSymbolType, Token> = {
  BTC: {
    name: "Bitcoin",
    symbol: PortfolioSymbol.BTC,
    addresses: {
      development: {
        [ChainId.ARBITRUM]: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
        [ChainId.ARBITRUM_SEPOLIA]:
          "0x5936504538d65aA018725EEE18f4969c416898fD",
      },
      sandbox: {
        [ChainId.ARBITRUM]: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
        [ChainId.ARBITRUM_SEPOLIA]:
          "0x5936504538d65aA018725EEE18f4969c416898fD",
      },
      staging: {
        [ChainId.ARBITRUM]: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
        [ChainId.ARBITRUM_SEPOLIA]:
          "0x5936504538d65aA018725EEE18f4969c416898fD",
      },
      production: {
        [ChainId.ARBITRUM]: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
        [ChainId.ARBITRUM_SEPOLIA]:
          "0x5936504538d65aA018725EEE18f4969c416898fD",
      },
    },
    decimals: 8,
    coinGeckoId: "bitcoin",
    logoURI:
      "https://coin-images.coingecko.com/coins/images/1/large/bitcoin.png",
  },
  ETH: {
    name: "Ethereum",
    symbol: PortfolioSymbol.ETH,
    addresses: {
      development: {
        [ChainId.ARBITRUM]: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        [ChainId.ARBITRUM_SEPOLIA]:
          "0x629Fa36abD4d6bC2d15613De70e2401b7ccb016A",
      },
      sandbox: {
        [ChainId.ARBITRUM]: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        [ChainId.ARBITRUM_SEPOLIA]:
          "0x629Fa36abD4d6bC2d15613De70e2401b7ccb016A",
      },
      staging: {
        [ChainId.ARBITRUM]: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        [ChainId.ARBITRUM_SEPOLIA]:
          "0x629Fa36abD4d6bC2d15613De70e2401b7ccb016A",
      },
      production: {
        [ChainId.ARBITRUM]: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        [ChainId.ARBITRUM_SEPOLIA]:
          "0x629Fa36abD4d6bC2d15613De70e2401b7ccb016A",
      },
    },
    decimals: 18,
    coinGeckoId: "ethereum",
    tags: ["native"],
    logoURI:
      "https://coin-images.coingecko.com/coins/images/279/large/ethereum.png",
  },
  USDC: {
    name: "USD Coin",
    symbol: PortfolioSymbol.USDC,
    addresses: {
      development: {
        [ChainId.ARBITRUM]: "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
        [ChainId.ARBITRUM_SEPOLIA]:
          "0x07a7D6b723d0aa62cD78da00452Ba3cD3b72C3d7",
      },
      sandbox: {
        [ChainId.ARBITRUM]: "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
        [ChainId.ARBITRUM_SEPOLIA]:
          "0x07a7D6b723d0aa62cD78da00452Ba3cD3b72C3d7",
      },
      staging: {
        [ChainId.ARBITRUM]: "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
        [ChainId.ARBITRUM_SEPOLIA]:
          "0x07a7D6b723d0aa62cD78da00452Ba3cD3b72C3d7",
      },
      production: {
        [ChainId.ARBITRUM]: "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
        [ChainId.ARBITRUM_SEPOLIA]:
          "0xA4387E780091cA2C479F71Bf5AC0cF729098c0C3", // not mintable
      },
    },
    decimals: 6,
    coinGeckoId: "usdc",
    tags: ["stablecoin"],
    logoURI:
      "https://coin-images.coingecko.com/coins/images/6319/large/usdc.png",
  },
} as const;

export const tokenAddresses = Object.fromEntries(
  Object.entries(tokens).map(([key, token]) => [
    key,
    token.addresses[environment],
  ]),
) as Record<PortfolioSymbolType, Record<ChainId, Address>>;
